import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Home from "./Home";
import AccountingPage from './AccountingPage';
import Contacts from './Contacts';
import VacanciesPage from './VacanciesPage';
import RoutesPage from './RoutesPage';
import ThreeDemoPage from './ThreeDemoPage';
import Terms from './Terms';
import Privacy from './Privacy';
import reportWebVitals from './reportWebVitals';
import ScrollToTop from './ScrollToTop';
import './modules/views/styles.scss';

ReactDOM.render(
  <React.StrictMode>
    <Router>
    <ScrollToTop />
    <Switch>
      <Route exact path="/" component={Home} />
      <Route exact path="/accounting" component={AccountingPage} />
      <Route exact path="/contacts" component={Contacts} />
      <Route exact path="/vacancies" component={VacanciesPage} />
      <Route exact path="/routes" component={RoutesPage} />
      <Route exact path="/3d-demo" component={ThreeDemoPage} />
      <Route path="/terms" component={Terms} />
      <Route path="/privacy" component={Privacy} />
    </Switch>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();  
